import { MutationTree } from 'vuex'
import { RegisterState } from './types'

export const mutations: MutationTree<RegisterState> = {
  gotoStep(state, step: number) {
    if (step < 0) {
      step = 0
    }

    if (step > state.stepMax) {
      step = state.stepMax
    }

    state.step = step
  },

  back(state) {
    let step = state.step - 1
    if (step < 0) {
      step = 0
    }
    state.step = step
  },

  next(state) {
    let step = state.step + 1
    if (step > state.stepMax) {
      step = state.stepMax
    }

    state.step = step
  },
}
